export default __webpack_public_path__ + "justhatched-screens_small@2x.06803426.png";